import { useEffect, useState, useRef } from 'react';

export default function WhyFounder() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const needs = [
    'Use it daily',
    'Tell us what works',
    "Tell us what doesn't",
    'Help us build the right features',
  ];

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-gradient-to-b from-[#09090b] to-[#0a0a0c]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8 sm:space-y-12">
          <h2
            className={`text-white text-[28px] sm:text-[36px] lg:text-[48px] font-black leading-tight transition-all duration-700 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            Why Founder Pricing
          </h2>

          <div
            className={`max-w-[800px] mx-auto space-y-6 sm:space-y-8 transition-all duration-700 delay-200 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <p className="text-[#d4d4d8] text-base sm:text-lg lg:text-xl leading-relaxed">
              We need founding members who will:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              {needs.map((need, index) => (
                <div
                  key={index}
                  className={`p-4 sm:p-6 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 hover:border-[#06b6d4] ${
                    animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                  style={{ transitionDelay: `${300 + index * 100}ms` }}
                >
                  <div className="flex items-start gap-3">
                    <span className="text-[#06b6d4] text-lg sm:text-xl mt-0.5">✓</span>
                    <p className="text-white text-sm sm:text-base lg:text-lg font-semibold">{need}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pt-6 sm:pt-8 space-y-4 sm:space-y-6">
              <p className="text-[#d4d4d8] text-base sm:text-lg lg:text-xl leading-relaxed">
                In exchange, you get the lowest price we'll ever charge. <span className="text-[#d4af37] font-bold">Locked in. Forever.</span>
              </p>

              <p className="text-white text-lg sm:text-xl lg:text-2xl font-bold">
                Even when we're charging $149/month. Even when we're charging $299/month.{' '}
                <span className="text-[#d4af37]">Your rate stays $25.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
